import { Trophy, CalendarDays, Users } from "lucide-react";
import { PlayerAvatar } from "./PlayerAvatar";

export function Hero({ matchdays, standings, nextMd }) {
  const total = matchdays.length;
  const current = nextMd ? nextMd.number : total;
  const leader = standings[0];
  const top3 = standings.slice(0, 3);

  const dateFmt = (d) => {
    if (!d) return "Da definire";
    try {
      return new Date(d).toLocaleDateString("it-IT", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    } catch {
      return d;
    }
  };

  return (
    <section className="relative overflow-hidden border-b border-white/10 ap-ambient">
      <div
        className="absolute inset-0 opacity-[0.18]"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1554068865-24cecd4e34b8?crop=entropy&cs=srgb&fm=jpg&q=70&w=1600)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F19] via-[#0B0F19]/90 to-[#0B0F19]/40" />
      <div className="absolute left-0 top-0 h-full w-1.5 bg-gradient-to-b from-emerald-400 via-cyan-400 to-emerald-700" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-16 grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7 ap-rise">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/30 mb-4">
            <span className="w-2 h-2 rounded-full bg-emerald-400 ap-live-dot" />
            <span className="font-mono text-xs text-emerald-300 tracking-[0.2em]">
              GIORNATA {current} DI {total}
            </span>
          </div>
          <h1 className="font-display font-black uppercase leading-[0.92] tracking-tight text-5xl sm:text-6xl lg:text-7xl text-white">
            Campionato
            <br />
            <span className="text-emerald-400">Americana</span> 2026
          </h1>
          <p className="mt-4 text-slate-300 text-sm sm:text-base max-w-lg leading-relaxed">
            12 giocatori, coppie che ruotano ogni giornata, una sola classifica
            individuale. Segui calendario, risultati e statistiche in tempo reale.
          </p>

          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-3 max-w-xl">
            {[
              { icon: Users, label: "Giocatori", value: "12", tone: "text-emerald-400" },
              { icon: CalendarDays, label: "Giornate", value: String(total), tone: "text-cyan-400" },
              { icon: Trophy, label: "Formato", value: "Americana", tone: "text-amber-400", small: true },
            ].map((s) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.label}
                  className="ap-card !rounded-xl px-4 py-3 flex items-center gap-3"
                >
                  <Icon className={`w-5 h-5 ${s.tone}`} />
                  <div className="leading-tight">
                    <div className={`font-display font-black ${s.small ? "text-base" : "text-xl"} text-white`}>
                      {s.value}
                    </div>
                    <div className="text-[10px] uppercase tracking-wider text-slate-500">{s.label}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="lg:col-span-5 ap-rise" style={{ animationDelay: "0.1s" }}>
          <div className="ap-glass rounded-2xl p-5 sm:p-6 shadow-2xl">
            <div className="flex items-center justify-between gap-2 mb-4">
              <div className="flex items-center gap-2">
                <Trophy className="w-4 h-4 text-amber-400" />
                <span className="font-display uppercase tracking-wide text-sm text-slate-300">
                  Podio attuale
                </span>
              </div>
              <span className="font-mono text-[10px] text-slate-500 tracking-widest uppercase">
                Prossima: <span className="text-slate-300 capitalize">{dateFmt(nextMd?.date)}</span>
              </span>
            </div>
            {leader ? (
              <div className="space-y-2.5">
                {top3.map((p, i) => {
                  const medals = ["#F59E0B", "#9CA3AF", "#D97706"];
                  const bg = ["bg-amber-500/10", "bg-slate-400/10", "bg-amber-700/10"];
                  return (
                    <div
                      key={p.player_id}
                      className={`flex items-center justify-between gap-3 px-3 py-2.5 rounded-xl border border-white/5 ${bg[i]}`}
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <span
                          className="font-display font-black text-lg w-6 text-center"
                          style={{ color: medals[i] }}
                        >
                          {i + 1}
                        </span>
                        <PlayerAvatar id={p.player_id} name={p.name} size={34} />
                        <span className="font-semibold text-white truncate">{p.name}</span>
                      </div>
                      <span className="font-mono font-bold text-emerald-400 text-lg">{p.points}</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-slate-500 text-sm">Nessun risultato ancora registrato.</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
